/**
 * Language code to language name mapping
 * Maps ISO 639-1 language codes to their display names
 */
export const LANGUAGE_NAME_MAP: Record<string, string> = {
  // Common languages
  'en': 'English',
  'es': 'Español',
  'hi': 'हिन्दी',
  'fr': 'Français',
  'de': 'Deutsch',
  'it': 'Italiano',
  'pt': 'Português',
  'ru': 'Русский',
  'ja': '日本語',
  'ko': '한국어',
  'zh': '中文',
  'ar': 'العربية',
  'tr': 'Türkçe',
  'pl': 'Polski',
  'nl': 'Nederlands',
  'sv': 'Svenska',
  'da': 'Dansk',
  'no': 'Norsk',
  'fi': 'Suomi',
  'cs': 'Čeština',
  'hu': 'Magyar',
  'ro': 'Română',
  'el': 'Ελληνικά',
  'he': 'עברית',
  'th': 'ไทย',
  'vi': 'Tiếng Việt',
  'id': 'Bahasa Indonesia',
  'ms': 'Bahasa Melayu',
  'tl': 'Tagalog',
  'uk': 'Українська',
  'bg': 'Български',
  'hr': 'Hrvatski',
  'sk': 'Slovenčina',
  'sl': 'Slovenščina',
  'sr': 'Српски',
  'mk': 'Македонски',
  'sq': 'Shqip',
  'et': 'Eesti',
  'lv': 'Latviešu',
  'lt': 'Lietuvių',
  'ga': 'Gaeilge',
  'mt': 'Malti',
  'is': 'Íslenska',
  'fa': 'فارسی',
  'ur': 'اردو',
  'bn': 'বাংলা',
  'ta': 'தமிழ்',
  'te': 'తెలుగు',
  'ml': 'മലയാളം',
  'kn': 'ಕನ್ನಡ',
  'gu': 'ગુજરાતી',
  'pa': 'ਪੰਜਾਬੀ',
  'mr': 'मराठी',
  'ne': 'नेपाली',
  'si': 'සිංහල',
  'my': 'မြန်မာ',
  'km': 'ខ្មែរ',
  'lo': 'ລາວ',
  'ka': 'ქართული',
  'am': 'አማርኛ',
  'sw': 'Kiswahili',
  'zu': 'isiZulu',
  'af': 'Afrikaans',
  'eu': 'Euskara',
  'ca': 'Català',
  'gl': 'Galego',
  'cy': 'Cymraeg',
  'br': 'Brezhoneg',
  'gd': 'Gàidhlig',
  'be': 'Беларуская',
  'kk': 'Қазақ',
  'ky': 'Кыргызча',
  'az': 'Azərbaycan',
  'hy': 'Հայերեն',
  'mn': 'Монгол',
  'bo': 'བོད་སྐད་',
  'dz': 'རྫོང་ཁ',
  'jw': 'Basa Jawa',
  'su': 'Basa Sunda',
  'ceb': 'Cebuano',
  'mg': 'Malagasy',
  'yo': 'Yorùbá',
  'ig': 'Igbo',
  'ha': 'Hausa',
  'xh': 'isiXhosa',
  'st': 'Sesotho',
  'tn': 'Setswana',
  've': 'Tshivenḓa',
  'ts': 'Xitsonga',
  'ss': 'siSwati',
  'nr': 'isiNdebele',
  'nso': 'Sesotho sa Leboa'
};

/**
 * Get language display name from language code
 * Falls back to uppercase code if mapping not found
 */
export const getLanguageName = (code: string): string => {
  return LANGUAGE_NAME_MAP[code.toLowerCase()] || code.toUpperCase();
};
